import types from '../types';

/**
 * @param {types.CheckBoxOrRadioOption[]} options
 * @param {string} id
 * @returns {types.CheckBoxOrRadioOption[]}
 */
const getCheckboxGroupNextState = (options, id) => {
    if (!options || !Array.isArray(options) || !options.length) {
        throw new Error('Options are missing!');
    }

    return options.map(option => {
        let { checked } = option;

        /* toggle state */
        if (option.id === id) {
            checked = !checked;
        }

        if (
            option.subcategoriesContent &&
            option.subcategoriesContent.subcategories &&
            option.subcategoriesContent.subcategories.length
        ) {
            const nextSubcategories = option.subcategoriesContent.subcategories.map(
                item => {
                    const subcategoryIsChanged = item.id === id;

                    let subcategoryChecked = item.checked;

                    if (subcategoryIsChanged) {
                        subcategoryChecked = !subcategoryChecked;
                    }

                    return {
                        ...item,
                        checked: !checked ? false : subcategoryChecked
                    };
                }
            );

            return {
                ...option,
                checked,
                subcategoriesContent: {
                    ...option.subcategoriesContent,
                    subcategories: nextSubcategories
                }
            };
        }

        return {
            ...option,
            checked
        };
    });
};

export default getCheckboxGroupNextState;
